import React, { Component } from "react";
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import ScrollIntoView from "react-scroll-into-view";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Pagination from "@material-ui/lab/Pagination";
import { Grid, Button } from "@material-ui/core";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Axios from "axios";

import { url } from "../../../config/config";
import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";
import BrowseBook from "../../../Assets/Images/BrowseBook.png";
import BookSidebar from "./BookSidebar/BookSidebar";
import BookItem from "./BookItem/BookItem";
import CustomLoader from "../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import { useStyles } from "./Books.css";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#0a1f3a",
    },
  },
});

class Books extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      postPerPage: 9,
      books: [],
      cartCount: 0,
      isEmpty: false,
      notificationOpen: false,
      alreadyExist: "",
      success: "",
    };
  }

  componentDidMount() {
    this.getBookData();
    if (this.props.isAuth) {
      this.getCartCount();
    }
  }

  getBookData = async () => {
    const response = await Axios.get(`${url}/api/books`);
    if (response.data.length !== 0) {
      this.setState({
        books: response.data,
        isEmpty: false,
      });
    } else {
      this.setState({
        books: [],
        isEmpty: true,
      });
    }
  };

  getCartCount = async () => {
    const response = await Axios.get(`${url}/api/carts/cartDetails`, {
      headers: {
        "x-auth-token": this.props.userToken,
      },
    });
    this.setState({
      cartCount: response.data.cart.length,
    });
  };

  handleCart = async (bookId) => {
    if (this.props.isAuth) {
      const response = await Axios.post(
        `${url}/api/carts/addToCart`,
        { bookId: bookId },
        {
          headers: {
            "x-auth-token": this.props.userToken,
          },
        }
      );
      if (response.data.bookInCart) {
        this.setState({
          alreadyExist: response.data.bookInCart,
          success: "",
        });
        this.getCartCount();
        this.handleNotificationOpen();
      }
      if (response.data.success) {
        this.setState({
          success: response.data.success,
          alreadyExist: "",
        });
        this.getCartCount();
        this.handleNotificationOpen();
      }
    } else {
      this.props.history.push("/login/Customer");
    }
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = (notificationStyle, message) => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        className={notificationStyle}
        autoHideDuration={1600}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="success"
          elevation={6}
          variant="filled"
        >
          {message}
        </MuiAlert>
      </SnackBar>
    );
  };

  handlePage = (e, value) => {
    this.setState({
      currentPage: value,
    });
  };

  compare = (a, b) => {
    const nameA = a.title.toUpperCase();
    const nameB = b.title.toUpperCase();

    let comparison = 0;
    if (nameA > nameB) {
      comparison = 1;
    } else if (nameA < nameB) {
      comparison = -1;
    }
    return comparison;
  };

  handleBook = (bookId) => {
    this.props.history.push(`/books/details/${bookId}`);
  };

  handleBuyBook = (bookId) => {
    this.props.history.push(`/book/buy/${bookId}`);
  };

  render() {
    const { classes } = this.props;
    const { currentPage, postPerPage } = this.state;
    this.state.books.sort(this.compare);
    return (
      <div>
        <Header cartCount={this.state.cartCount} />
        <div
          id="main"
          className={classes.mainBrowse}
          style={{
            backgroundImage: `url(${BrowseBook})`,
          }}
        >
          <div
            style={{
              padding: 20,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h1
              style={{ fontSize: 50, fontWeight: "bolder", color: "#000082" }}
            >
              Explore the vast world of books
            </h1>
            <ScrollIntoView selector="#category">
              <Button
                disableRipple
                variant="outlined"
                className={classes.titleButtonStyle}
              >
                Browse Book
              </Button>
            </ScrollIntoView>
          </div>
        </div>
        <br />

        {this.state.books.length !== 0 ? (
          <div id="category" className={classes.root}>
            <Grid container spacing={2} className={classes.gridContainer}>
              <BookSidebar />

              <Grid item container xs={12} sm={12} md={9} xl={9} lg={9}>
                {this.state.books
                  .slice(
                    (currentPage - 1) * postPerPage,
                    (currentPage - 1) * postPerPage + postPerPage
                  )
                  .map((book, index) => (
                    <BookItem
                      key={index}
                      book={book}
                      handleBook={this.handleBook}
                      handleBuyBook={this.handleBuyBook}
                      handleCart={this.handleCart}
                    />
                  ))}
              </Grid>
              {this.state.success
                ? this.showNotification(
                    classes.notificationStyle,
                    this.state.success
                  )
                : this.showNotification(
                    classes.notificationStyle,
                    this.state.alreadyExist
                  )}
            </Grid>
            <div className={classes.paginationStyle}>
              <ThemeProvider theme={theme}>
                <Pagination
                  count={Math.ceil(this.state.books.length / postPerPage)}
                  color="primary"
                  page={currentPage}
                  boundaryCount={1}
                  onChange={this.handlePage}
                  showFirstButton
                  showLastButton
                />
              </ThemeProvider>
            </div>
          </div>
        ) : this.state.isEmpty === false ? (
          <CustomLoader />
        ) : (
          <CustomEmptyMessage message="There is no any book published yet." />
        )}
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.UserReducer.isAuth,
    userToken: state.UserReducer.token,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(Books)));
